import { ALLOCATION_SEGMENT_COLORS } from 'views/household/asset-allocation-presentation';
import { AssetAllocation } from 'views/household/holdings';

export const PolicyAllocation = ({ allocation, donut = false }: { allocation: AssetAllocation; donut?: boolean }) => {
    const { total, segments } = allocation;
    if (donut) {
        let offset = 0;
        return (
            <svg viewBox="0 0 38 38" className="h-18 w-18 shrink-0 -rotate-90" role="img" aria-label="Asset allocation">
                <circle cx="19" cy="19" r="14" fill="none" strokeWidth="9" className="stroke-cocoa-100" />
                {segments.map((segment) => {
                    const weight = total > 0 ? (segment.amount / total) * 100 : 0;
                    const start = offset;
                    offset += weight;
                    return (
                        <circle
                            key={segment.key}
                            cx="19"
                            cy="19"
                            r="14"
                            fill="none"
                            strokeWidth="9"
                            pathLength="100"
                            strokeDasharray={`${weight} ${100 - weight}`}
                            strokeDashoffset={-start}
                            style={{
                                stroke: `var(--color-${ALLOCATION_SEGMENT_COLORS[segment.key].replace('bg-', '')})`,
                            }}
                        />
                    );
                })}
            </svg>
        );
    }
    return (
        <div className="bg-cocoa-100 flex h-1.5 overflow-hidden rounded-full" role="img" aria-label="Asset allocation">
            {segments.map((segment) => (
                <span
                    key={segment.key}
                    className={ALLOCATION_SEGMENT_COLORS[segment.key]}
                    style={{ width: `${total > 0 ? (segment.amount / total) * 100 : 0}%` }}
                />
            ))}
        </div>
    );
};
